const axios = require('axios');

import {FAV_URL_FEED} from "../consts";

export default async (id, h) => {
    const promise = new Promise((resolve, reject) => {
        if (typeof window.fav === 'undefined') {
            axios.get(FAV_URL_FEED + `?i=${id}&h=${h}`).then((response) => {
                window.fav = response.data;
                resolve(window.fav);
            });
        } else {
            resolve(window.fav);
        }
    });
    return promise;
}
